export default "__VITE_ASSET__Bii$TjGR__"